/**
 * Created by handd on 2018/12/20.
 */
import axios from "axios";
//import {browserHistory} from "react-router";

// const
const REDIRECT_TO_RESOURCE_ADD_PAGE = "resourceAdd/REDIRECT_TO_RESOURCE_ADD_PAGE";
const RESOURCE_ADD_INITIAL_DATA = "resourceAdd/RESOURCE_ADD_INITIAL_DATA";
const RESOURCE_ADD_UPDATE_DATA = "resourceAdd/RESOURCE_ADD_UPDATE_DATA";
const RESOURCE_ADD_TOGGLE_MODAL = "resourceAdd/RESOURCE_ADD_TOGGLE_MODAL";
const RESOURCE_ADD_TOGGLE_LOADING = "resourceAdd/RESOURCE_ADD_TOGGLE_LOADING";
const RESOURCE_ADD_TOGGLE_SELECT = "resourceAdd/RESOURCE_ADD_TOGGLE_SELECT";

// modal const
const RESOURCE_ADD_MODAL_SUCCESS_TITLE = "scenes_Application_ResourceAdd_modal_success_title";
const RESOURCE_ADD_MODAL_FAIL_TITLE = "scenes_Application_ResourceAdd_modal_fail_title";
const RESOURCE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Application_ResourceAdd_modal_submitSuccess_content";
const RESOURCE_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Application_ResourceAdd_modal_submitFail_content";
const RESOURCE_ADD_MODAL_OK_LABEL = "scenes_Application_ResourceAdd_modal_OK_label";
const RESOURCE_ADD_MODAL_CANCEL_LABEL = "scenes_Application_ResourceAdd_modal_cancel_label";


// reducer
export const resourceAdd = (state = {
  loading: false,
  flag: "",
  rowKey: 1,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  periods: [],
  applicationId: "",

}, action) => {
  switch (action.type) {
    case REDIRECT_TO_RESOURCE_ADD_PAGE:
      return {
        ...state,
        applicationId: action.data
      };
    case RESOURCE_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case RESOURCE_ADD_INITIAL_DATA:
      return {
        ...state,
        modalVisible: false,
        rowKey: 1,
        applicationId: action.data.applicationId,
        flag: action.data.flag,
        periods: [{
          key: 0,
          name: "一个月",
          number: 1,
          timeUnit: "MONTH",
          times: 1,
          limit: 9,
          discount: 1.0,
          remark: "按月购买，九个月以上选购包年"
        }],
      };
    case RESOURCE_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case RESOURCE_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateResourceData = (data) => {
  return {
    type: RESOURCE_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init application plan
 */
export const initResource = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/checkApplicationId/${data.applicationId}`, {contentType: "application/json"}).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.data) {
        dispatch(storeInitResource(data));
      } else {
        this.props.history.push("/exception/415");
      }
    }
  );
};

/**
 * store init resource
 */
export const storeInitResource = (applicationId) => {
  return {
    type: RESOURCE_ADD_INITIAL_DATA,
    data: applicationId
  }
};

export const submitResource = (data, history, flag) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: "/api-application/createResource",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "name": data.name,
      "code": data.code,
      "description": data.description,
      "resourceParameters": [
        {"name": "CPU_CORES", "value": data.isCpuCores ? data.cpuCores : 1},
        {"name": "MEMORY_QUOTA", "value": data.isMemoryQuota ? data.memoryQuota : 1024},
        {"name": "DISK_QUOTA", "value": data.isDiskQuota ? data.diskQuota : 512},
        {"name": "CONCURRENT_USER", "value": data.isConcurrentUser ? data.concurrentUser : -1},
      ],
      "price": data.price,
      "periods": data.periods,
      "ifPermanent": data.ifPermanent,
      "permanentPrice": data.permanentPrice,
      "createUserId": data.releaseUserId,
      "createUserName": data.releaseUserName,
      "application": {
        "id": data.applicationId,
        "cost": data.price
      },
      "ifEnabled": true
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success submit resource");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: RESOURCE_ADD_MODAL_SUCCESS_TITLE,
          modalContent: RESOURCE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: RESOURCE_ADD_MODAL_OK_LABEL,
          modalCancel: RESOURCE_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            history.push(`/console/application-edit?id=${data.applicationId}&flag=${flag}`);
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            history.push(`/console/application-edit?id=${data.applicationId}&flag=${flag}`);
          }
        }));
      } else {
        console.error("fail to submit resource");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: RESOURCE_ADD_MODAL_FAIL_TITLE,
          modalContent: RESOURCE_ADD_MODAL_SUBMIT_FAIL_CONTENT,
          modalOk: RESOURCE_ADD_MODAL_OK_LABEL,
          modalCancel: RESOURCE_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          }
        }));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: RESOURCE_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: RESOURCE_ADD_TOGGLE_LOADING,
    data: show
  }
};
